/** * 左边菜单 */
<template>
  <el-menu :collapse="collapsed" collapse-transition router :default-active="path" unique-opened
    class="el-menu-vertical-demo" background-color="#334157" text-color="#fff" active-text-color="#ffd04b">
    <div class="logobox">
      <img class="logoimg" src="../assets/img/logo.png" alt="" />
    </div>
    <el-menu-item :key="menu.path" :index="menu.path" v-for="menu in allmenu">
      <span>{{ menu.name }}</span>
    </el-menu-item>
    <!-- <el-submenu
      v-for="menu in allmenu"
      :key="menu.menuid"
      :index="menu.menuname"
    >
      <template slot="title">
        <i class="iconfont" :class="menu.icon"></i>
        <span>{{ menu.menuname }}</span>
      </template>
<el-menu-item-group>
  <el-menu-item v-for="chmenu in menu.menus" :index="'/' + chmenu.url" :key="chmenu.menuid">
    <i class="iconfont" :class="chmenu.icon"></i>
    <span>{{ chmenu.menuname }}</span>
  </el-menu-item>
</el-menu-item-group>
</el-submenu> -->
  </el-menu>
</template>
<script>
import router, { resetRouter } from "@/router/index.js";
import { RouterLists } from '@/router/list.js'
import { getMenu } from '../api/userMG'
export default {
  name: "leftnav",
  data() {
    return {
      collapsed: false,
      allmenu: [],
      menuList: []
    };
  },
  computed: {

    path() {
      let url = this.$route.path;
      this.allmenu.forEach(item => {
        if (url.indexOf(item.path) > -1) {
          url = item.path;
        }
      });
      return url;
    }
  },
  mounted() {
    if (this.isShow()) return
    this.setMenus()
  },
  // 创建完毕状态(里面是操作)
  created() {
    // router.addRoute()

    // 监听
    this.$root.Bus.$on("toggle", value => {
      this.collapsed = !value;
    });
  },
  methods: {
    isShow() {
      return this.$route.path == '/login'
    },
    setMenus() {
      console.log('dsadad')
      let token = localStorage.getItem("logintoken");
      if (token) {
        getMenu().then(res => {
          if (res.code == 0) {
            this.$store.commit("logout", "false");
            this.$router.push({ path: "/login" });
            return
          }
          this.allmenu = []
          this.menuList = []
          router.options.routes.forEach(item => {
            if (item.meta && item.meta.requireAuth) {
              this.allmenu.push({
                name: item.name,
                path: item.path
              })
            }
          })
          res.data.forEach(item => {
            let obj = RouterLists.find(it => it.path == item.menu_path)
            if (obj) {
              // router.addRoute(obj)
              this.allmenu.push({
                name: item.menu_name,
                path: item.menu_path
              })
            }
          })

        })

      } else {
        this.$store.commit("logout", "false");
        this.$router.push({ path: "/login" });
      }

    }
  }
};
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}

.el-menu-item-group__title {
  padding: 0px;
}

.el-menu-bg {
  background-color: #1f2d3d !important;
}

.el-menu {
  border: none;
}

.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}

.logoimg {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue